/*global process*/
import React, { Component,lazy,Suspense} from "react";
import { Switch, Route, withRouter, NavLink } from "react-router-dom";
import styled from "styled-components";
import ReactGA from "react-ga";
import Loader from '../components/loader/loader';

// import Home from "./home/home";
// import Search from "./search/index";
// import Detail from "./detail/index";
import Navbar from "../components/navbar/navbar";
// import Footer from "../components/footer/footer";
// import Browse from "./browse/index";
// import Chart from "./chart/index";
// import BrowseList from "./browse/list";
// import About from "./about/";
// import Help from "./help/";
// import NoMatch from "./noMatch";
import App from "../components/app";
// import Tablists from "./geodata/tabList"
import { baseStyles } from "../components/styled/global/index";
import 'babel-polyfill';
// import GeodataItems from "./geodata/geodataitems";
const Home =lazy(()=> import("./home/home"));
const Search = lazy(()=> import("./search/index"));
const Detail = lazy(()=> import("./detail/index"));
// const Navbar = lazy(()=> import("../components/navbar/navbar"));
const Footer = lazy(()=> import("../components/footer/footer"));
const Browse = lazy(()=> import("./browse/index"));
const Chart = lazy(()=> import("./chart/index"));
const BrowseList = lazy(()=> import("./browse/list"));
const About = lazy(()=> import("./about/"));
const Help = lazy(()=> import("./help/"));
const NoMatch= lazy(()=> import("./noMatch"));
// const App = lazy(()=> import("../components/app"));
const Tablists = lazy(()=> import("./geodata/tabList"));
const GeodataItems = lazy(()=>import("./geodata/geodataitems"))


class Index extends Component {
  componentWillMount() {
    if (process.env.NODE_ENV !== "development") {
      ReactGA.initialize("UA-118962167-2");
    }
    this.unlisten = this.props.history.listen((location, action) => {
      if (process.env.NODE_ENV !== "development") {
        ReactGA.ga("set", "page", document.location.pathname + document.location.search);
        ReactGA.ga("send", "pageview");
      }
    });
    
  }

  componentWillUnmount() {
    this.unlisten();
}

  render() {
    //apply global styles
    baseStyles();
    return this.props.location.pathname.indexOf("/chart") !== -1 ? (
      <Route exact path="/chart/:id" component={Chart} />
    ) : (
      
      <App>
        <Navbar />
        {/* <NavLink exact to="/">
                  Home
                </NavLink>
                <NavLink to="/about">
                  About
                </NavLink> */}
                
                <Suspense fallback={
                  <div></div>
                
              }>       
        <Switch>
          <Route exact path="/" render={props => <Home  {...props}/>} />
          <Route exact path="/search" render={props => <Search  {...props}/>} />
          <Route exact path="/series/:id" render={props => <Detail  {...props}/>} />
          <Route exact path="/browse/:id" render={props => <Browse  {...props}/>} />
          <Route exact path="/tags/:id" render={props => <BrowseList  {...props}/>} />
          <Route exact path="/category/:id" render={props => <BrowseList  {...props}/>} />
          <Route exact path="/sources/:id" render={props => <BrowseList  {...props}/>} />
          <Route exact path="/about" render={props => <About  {...props}/>} />
          <Route exact path="/help" render={props => <Help  {...props}/>} />
          <Route exact path="/geodata" render={props => <Tablists  {...props}/>} />
          <Route exact path="/geodata/:id" render={props => <GeodataItems  {...props}/>}  />
          <Route render={props => <NoMatch  {...props}/>} />

        </Switch>
        <Footer />
        </Suspense>

        
      
      </App>
    
    );
  }
}

export default withRouter(Index);

// const Curtain = styled.div`
//   #curtain1 {
//     top: 0px;
//     position: absolute;
//     left: 0px;
//     height: 100%;
//     width: 50%;
//     z-index: 999;
//   }
//   #curtain2 {
//     z-index: 999;
//     top: 0px;
//     width: 50%;
//     position: absolute;
//     height: 100%;
//     right: 0px;
//   }
// `;



// WEBPACK FOOTER //
// ./src/app/layouts/index.js